import { Ban } from "lucide-react";
import { PrivateHeader } from "@/components/dashboard/PrivateHeader";

export const DeactivatedView = ({ me, theme, onToggleTheme }) => {
  return (
    <div data-testid="deactivated-view" className="min-h-screen bg-[var(--pv-bg)] text-[var(--pv-text-2)]">
      <PrivateHeader
        title="My dashboard"
        theme={theme}
        onToggleTheme={onToggleTheme}
        badge={<span className="rounded-full bg-rose-500/15 px-2.5 py-0.5 text-[10px] font-bold uppercase text-rose-300">Deactivated</span>}
      />
      <main className="mx-auto max-w-2xl px-4 py-16 sm:px-6">
        <div className="rounded-3xl border border-[var(--pv-border)] bg-[var(--pv-card)] p-10 text-center ">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-500/10">
            <Ban className="h-7 w-7 text-rose-500" />
          </span>
          <h1 data-testid="deactivated-title" className="mt-6 font-display text-2xl font-bold tracking-tight text-[var(--pv-text)]">
            Production access disabled
          </h1>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-[var(--pv-text-4)]">
            Your account ({me.email}) and all historical information are preserved, but production access is
            currently disabled for this account. If you think this is a mistake, reply to any Melto Studios email to reach the team.
          </p>
        </div>
      </main>
    </div>
  );
};
